import React from 'react';
import { useSelector } from 'react-redux';
import { getDatasourceTables } from '@/store-selectors';
import ResizeableSidebar from '@/components/ResizeableSidebar';
import StepsSidebar from '@/containers/StepsSidebar';
import { AvailableButtons } from '@/components/StartNewQuery/types';
import {
  CSV_BUTTON,
  SAVED_QUERIES_BUTTON,
  SQL_BUTTON,
  TABLES_BUTTON,
} from '@/components/StartNewQuery/buttons.constants';
import { useDataPresentationParam } from '@/hooks';

const AVAILABLE_BUTTONS: AvailableButtons[] = [
  TABLES_BUTTON,
  SQL_BUTTON,
  CSV_BUTTON,
  SAVED_QUERIES_BUTTON,
];

export const QueryStepsSidebar = () => {
  const isVisible = !useDataPresentationParam();
  const noOfTables = useSelector(getDatasourceTables).length;

  return (
    <ResizeableSidebar
      initialWidth={425}
      isVisible={isVisible && noOfTables > 0}
      withToggleButton
    >
      <StepsSidebar
        sidebarOpen={isVisible}
        availableButtons={AVAILABLE_BUTTONS}
      />
    </ResizeableSidebar>
  );
};
